import { SubpageContentBlocks } from "@components/page/SubpageContentBlocks"
import { defineView } from "eddev/views"

export default defineView("page", (props) => {
  return (
    <>
      <SubpageContentBlocks blocks={props.page?.contentBlocks} />
      <div className="h-10" />
    </>
  )
})
